
class UrlHelper {

  constructor() {
    this.url = window.location.origin + window.location.pathname;
    this.params = new URLSearchParams(window.location.search);
  }

  getParam = (param) => {
    this.params = new URLSearchParams(window.location.search);
    return this.params.get(param);
  }

  setParam = (param, value) => {
    this.params.has(param)
      ? this.params.set(param, value)
      : this.params.append(param, value)

    this.rewriteUrl()
  }

  deleteParam = (param) => {
    this.params.delete(param);
    this.rewriteUrl();
  }

  rewriteUrl = () => {
    history.replaceState(null, null, `${window.location.pathname}?${this.params.toString()}`)
  }
}

const Url = new UrlHelper();

export default Url;
